var _polygon, _rect, _path, _ellipse, _path2, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogisticsRafiki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-404"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.68,348.92h-17c-8.85,0-16,12.83-16,28.66s7.17,28.65,16,28.65h17c8.85,0,16-12.83,16-28.65S306.53,348.92,297.68,348.92Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-404"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.04,
    y: 388.78,
    width: 23.18,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.1,
    y: 394.14,
    width: 56.67,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.72,
    y: 394.14,
    width: 56.67,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71h0V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.48,5.48,0,0,0,5.46-5.46V60.66A5.48,5.48,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.73,5.73,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.7,5.7,0,0,1,453.31,337.8ZM260.21,55.2a5.48,5.48,0,0,0-5.46,5.46V332.09a5.48,5.48,0,0,0,5.46,5.46h193.1a5.48,5.48,0,0,0,5.46-5.46V60.66a5.48,5.48,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7,130.41H182a6.37,6.37,0,0,1,6.38,6.38V382.17h-96V136.78A6.38,6.38,0,0,1,98.7,130.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.3,
    y: 145.28,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 145.28,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.86,
    y: 145.28,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.43,
    y: 145.28,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.3,
    y: 188.79,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 188.79,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.86,
    y: 188.79,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.43,
    y: 188.79,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.3,
    y: 232.29,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 232.29,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.86,
    y: 232.29,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.43,
    y: 232.29,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.3,
    y: 275.8,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 275.8,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.86,
    y: 275.8,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.43,
    y: 275.8,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.3,
    y: 319.3,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 319.3,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.86,
    y: 319.3,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.43,
    y: 319.3,
    width: 12.38,
    height: 27.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.94,153.28h59.64a5.2,5.2,0,0,1,5.19,5.19v223.7h-70V158.48A5.2,5.2,0,0,1,393.94,153.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.67,
    y: 166.81,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.19,
    y: 166.81,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 166.81,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.67,
    y: 206.36,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.19,
    y: 206.36,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 206.36,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.67,
    y: 245.92,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.19,
    y: 245.92,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 245.92,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.67,
    y: 285.46,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.19,
    y: 285.46,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 285.46,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.67,
    y: 325.02,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.19,
    y: 325.02,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 325.02,
    width: 11.25,
    height: 25.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.31,89.26h96.88a7.42,7.42,0,0,1,7.42,7.42V382.17H249.9V96.68A7.42,7.42,0,0,1,257.31,89.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.17,
    y: 106.57,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.93,
    y: 106.57,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.42,
    y: 106.57,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.68,
    y: 106.57,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.17,
    y: 157.19,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.93,
    y: 157.19,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.42,
    y: 157.19,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.68,
    y: 157.19,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.17,
    y: 207.81,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.93,
    y: 207.81,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.42,
    y: 207.81,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.68,
    y: 207.81,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.17,
    y: 258.42,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.93,
    y: 258.42,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.42,
    y: 258.42,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.68,
    y: 258.42,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.17,
    y: 309.03,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.93,
    y: 309.03,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.42,
    y: 309.03,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.68,
    y: 309.03,
    width: 14.4,
    height: 32.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.35,
    y: 194.17,
    width: 61.54,
    height: 188.01,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.62,
    y: 214.3,
    width: 27.19,
    height: 167.87,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.32 382.17 38.46 382.17 38.46 303.68 92.32 285.46 92.32 382.17",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-62--inject-404"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-62--inject-404",
    cx: 250,
    cy: 411.67,
    rx: 193.89,
    ry: 15.89,
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Truck--inject-404"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.68,348.92h-17c-8.85,0-16,12.83-16,28.66s7.17,28.65,16,28.65h17c8.85,0,16-12.83,16-28.65S306.53,348.92,297.68,348.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-404)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.68,348.92h-17c-8.85,0-16,12.83-16,28.66s7.17,28.65,16,28.65h17c8.85,0,16-12.83,16-28.65S326.53,348.92,317.68,348.92Z",
    style: {
      fill: "#fff",
      opacity: 0.05
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "435.39 355.06 137.7 354.85 137.7 164.7 435.39 164.7 435.39 355.06",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.63,
    y: 164.7,
    width: 201.76,
    height: 190.35,
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.7,
    y: 164.7,
    width: 95.93,
    height: 194.11,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 173.54,
    x2: 435.39,
    y2: 173.54,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 181.77,
    x2: 435.39,
    y2: 181.77,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 189.99,
    x2: 435.39,
    y2: 189.99,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 198.21,
    x2: 435.39,
    y2: 198.21,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 206.44,
    x2: 435.39,
    y2: 206.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 214.66,
    x2: 435.39,
    y2: 214.66,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 222.88,
    x2: 435.39,
    y2: 222.88,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 231.1,
    x2: 435.39,
    y2: 231.1,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 239.33,
    x2: 435.39,
    y2: 239.33,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 247.55,
    x2: 435.39,
    y2: 247.55,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 255.77,
    x2: 435.39,
    y2: 255.77,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 264,
    x2: 435.39,
    y2: 264,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 272.22,
    x2: 435.39,
    y2: 272.22,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 280.44,
    x2: 435.39,
    y2: 280.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 288.66,
    x2: 435.39,
    y2: 288.66,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 296.89,
    x2: 435.39,
    y2: 296.89,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 305.11,
    x2: 435.39,
    y2: 305.11,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 313.33,
    x2: 435.39,
    y2: 313.33,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 321.56,
    x2: 435.39,
    y2: 321.56,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 329.78,
    x2: 435.39,
    y2: 329.78,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 338,
    x2: 435.39,
    y2: 338,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.42,
    y1: 346.23,
    x2: 435.39,
    y2: 346.23,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.07,352.66H67.34c-8.2,0-14.84,11.88-14.84,26.54s6.64,26.53,14.84,26.53H83.07c8.2,0,14.84-11.88,14.84-26.53S91.27,352.66,83.07,352.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.08,352.66H87.34c-8.2,0-14.84,11.88-14.84,26.54s6.64,26.53,14.84,26.53h15.74c8.19,0,14.84-11.88,14.84-26.53S111.27,352.66,103.08,352.66Z",
    style: {
      fill: "#fff",
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,300.83H66.88c-1.46.05-2.66-1.51-2.69-3.49a3.22,3.22,0,0,1,0-.62l2-22.47c.25-2.31,1.68-4,3.4-4.11H77.1c1.45,0,2.65,1.53,2.68,3.51q0,.3,0,.6l-2,22.47C77.48,299,76,300.77,74.32,300.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.76,226.61,67.41,304,223.64,365.2l-1.09-152.52-34.36-1H94.07C88.41,211.63,83.42,217.71,81.76,226.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,239.06c-5.83-.26-11.06,4.52-12.77,11.65l-11.82,49.52H150.66l-1.24,65.33h74.83",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,296.07c-2.29,0-4.14-2.94-4.14-6.56a9.74,9.74,0,0,1,.18-1.88l8.59-45.44c.72-3.77,2.92-6.35,5.41-6.34h82.18c.89,0,1.62,1.14,1.62,2.56a3.74,3.74,0,0,1-.07.75c-1.8,9.36-7.65,40.37-9.89,52.23-.52,2.78-2.14,4.68-4,4.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.62,316.21a17.21,17.21,0,0,1-.17,2.38l-.43,2.93-.25,1.73-1.84,12.64-3,20.55-.83,5.71H36.81l0-5.71.08-20.55L37,323.6v-5c-1-6.6,2.19-13,7.05-14.33a6.52,6.52,0,0,1,1.75-.23H150.66C155.61,304,159.62,309.48,159.62,316.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.73,242v48.71c0,2.95-1.51,5.35-3.38,5.36H186.93c-1.87,0-3.38-2.4-3.38-5.36a8.57,8.57,0,0,1,.12-1.44l8.76-49.8c.42-2.39,1.82-4,3.38-3.91l19.66,1.08C217.29,236.75,218.73,239.12,218.73,242Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.94 235.85 116.24 235.85 98.21 296.07 113.92 296.07 131.94 235.85",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.16 235.85 136.66 235.85 118.64 296.07 126.13 296.07 144.16 235.85",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "189.75 335.89 189.75 356.44 36.83 356.44 36.91 335.89 189.75 335.89"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "168.45 335.89 154.31 335.89 128.88 350.83 128.88 356.44 189.75 356.44 189.75 335.89 168.45 335.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.19 350.83 63.19 356.44 36.83 356.44 36.91 335.89 37.77 335.89 63.19 350.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.71,365.56l-1.16-152.88-21-1c-5.24-.26-11.29,5.83-12.82,12.89L173.51,304h-5.93c-6.66,0-11.22,4.85-11.21,10l.09,51.58h67.25",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.23,322.24a1.35,1.35,0,0,1-.46,1,1.31,1.31,0,0,1-.9.35H37v-2.72h120.9a1.36,1.36,0,0,1,1.15.64A1.38,1.38,0,0,1,159.23,322.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.32 320.88 58.32 323.6 36.96 323.6 36.97 320.88 58.32 320.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.23,322.24a1.35,1.35,0,0,1-.46,1,1.31,1.31,0,0,1-.9.35H128.55v-2.72h29.32a1.36,1.36,0,0,1,1.15.64A1.38,1.38,0,0,1,159.23,322.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.73,360v.54a5,5,0,0,1-5,5H38.53a5,5,0,0,1-5-5V360a5,5,0,0,1,5-5h397.2A5,5,0,0,1,440.73,360Z",
    style: {
      fill: "#263238"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.41,
    y: 359.11,
    width: 59.2,
    height: 2.89
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.66,360.55A1.65,1.65,0,1,1,50,358.9,1.65,1.65,0,0,1,51.66,360.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.75,360.55a1.65,1.65,0,1,1-1.65-1.65A1.65,1.65,0,0,1,140.75,360.55Z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.59,376.93c0-15.91,7.21-28.81,16.11-28.81H187.61c-8.89,0-16.1,12.9-16.1,28.81s7.21,28.8,16.1,28.8H204.7C195.8,405.76,188.59,392.87,188.59,376.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.59,376.93c0-15.91,7.21-28.81,16.11-28.81H187.61c-8.89,0-16.1,12.9-16.1,28.81s7.21,28.8,16.1,28.8H204.7C195.8,405.76,188.59,392.87,188.59,376.93Z",
    style: {
      fill: "#263238",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.7,
    cy: 376.96,
    rx: 16.11,
    ry: 28.81,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.99,
    cy: 376.96,
    rx: 11.42,
    ry: 22.46,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.95,
    cy: 376.96,
    rx: 10.93,
    ry: 19.44,
    style: {
      fill: "#263238"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.55,
    cy: 376.96,
    rx: 7.98,
    ry: 14.19
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.73,360v.54a5,5,0,0,1-5,5H233.63V355h202.1A5,5,0,0,1,440.73,360Z",
    style: {
      opacity: 0.5
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M377.92,376.93c0-15.91,7.21-28.81,16.1-28.81H376.94c-8.9,0-16.11,12.9-16.11,28.81s7.21,28.8,16.11,28.8H394C385.13,405.76,377.92,392.87,377.92,376.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.92,376.93c0-15.91,7.21-28.81,16.1-28.81H376.94c-8.9,0-16.11,12.9-16.11,28.81s7.21,28.8,16.11,28.8H394C385.13,405.76,377.92,392.87,377.92,376.93Z",
    style: {
      fill: "#263238",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.02,
    cy: 376.96,
    rx: 16.11,
    ry: 28.81,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 395.32,
    cy: 376.96,
    rx: 11.42,
    ry: 22.46,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.27,
    cy: 376.96,
    rx: 10.93,
    ry: 19.44,
    style: {
      fill: "#263238"
    }
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.87,
    cy: 376.96,
    rx: 7.98,
    ry: 14.19
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-404"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.86,236c-.2,3.85-.55,7.57-1.12,11.36a63.37,63.37,0,0,1-2.56,11.53,19.5,19.5,0,0,1-1.43,3.16,9,9,0,0,1-1.44,1.86l-.28.26-.16.12-.08.07-.34.23-.67.47a36.37,36.37,0,0,1-5.34,2.83,61.16,61.16,0,0,1-10.93,3.62l-1.3-3.56c3.18-1.76,6.44-3.56,9.41-5.43a41.78,41.78,0,0,0,4.18-2.93l.44-.37.22-.19v0h0s.09-.15.2-.39a13.52,13.52,0,0,0,.72-2,44.58,44.58,0,0,0,1.07-5c.31-1.74.56-3.51.77-5.31.41-3.57.76-7.23,1-10.79Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.58,268l-6.14-1.9,1.15,7.43s4-.5,6-2.74Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,270.88l.34,1a2.7,2.7,0,0,0,2.69,1.81l3.13-.14L297,266.1l-3.44,1.35A2.72,2.72,0,0,0,292,270.88Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.12,228.79c0,2.32-1.12,6.9-2.08,10.34-.71,2.47-1.3,4.35-1.3,4.35l-1.41-.35-11.62-2.94c-.18-6,.05-12.53,6-16.45C329.43,221.28,336.09,224.66,336.12,228.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.11,229.19c-.76-.8-2.48-.94-6.23.25-5.37,1.7-6.87,7.58-6.94,11.57l8.39,2.12.72.19.69.16s.29-.94.71-2.37h0c.17-.58.38-1.26.58-2A54.34,54.34,0,0,0,336.11,229.19Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.27 415.47 305.18 412.99 309.64 397.63 316.72 400.12 312.27 415.47",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407 397.27 401.23 401.57 389.42 389.6 395.19 385.3 407 397.27",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.87,399.82l6.23-5.15a.58.58,0,0,1,.76,0l4.78,4.34a1.15,1.15,0,0,1,0,1.63l-.1.09c-2.2,1.76-3.36,2.5-6.1,4.76-1.68,1.39-5.21,4.72-7.54,6.64s-4.35-.27-3.55-1.28c3.57-4.52,4.4-7.5,4.82-9.94A1.93,1.93,0,0,1,398.87,399.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.7,410.77l7.88,3.29a.71.71,0,0,1,.42.74l-.89,6.95a1.06,1.06,0,0,1-1.18.92,1,1,0,0,1-.3-.08c-2.79-1.13-4.1-1.69-7.56-3.14L292.45,415c-2.88-1.21-2.26-4.37-1-4.14,5.83,1.06,9.59.71,11.89-.16A1.77,1.77,0,0,1,304.7,410.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.64 397.64 307.35 405.55 314.25 408.67 316.73 400.12 309.64 397.64",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.2 385.3 389.42 389.6 395.51 395.77 401.28 391.47 395.2 385.3",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,266.33l-29.2.42c-4-22.61-5-33.4-5-38.59a5.56,5.56,0,0,1,4.5-5.48c1.78-.35,4-.75,6.23-1.06.76-.1,1.53-.2,2.29-.28a93.16,93.16,0,0,1,13.26-.19c.66,0,1.31.06,2,.1,3,.19,5.74.57,7.69.87a2.68,2.68,0,0,1,2.22,3.07.77.77,0,0,1,0,.15c-.86,4-1.56,7.55-2.12,10.71-.89,5-1.45,9.08-1.78,12.64A110.52,110.52,0,0,0,357.92,266.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,248.72c-1.47-4.41-1.39-13.56.19-16.52l1.61,3.87C358.89,241.1,358.33,245.16,358,248.72Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.72,266.75s-5,42.51-9.51,69c-3.57,20.74-12.59,63.91-12.59,63.91l11.71,4.15s13.41-45,15.76-64.22c9.45-27.71,16.25-73.05,16.25-73.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.72 402.56 318.27 407.33 320.08 402.98 305.38 397.36 304.72 402.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.52,279.38l-4.38,8.39c-1.6,6.32-1.22,21.7.81,31.42,3.64-14.65,6.55-30.07,8.36-40.42Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.06,266.75s5.23,47.58,15,74c4.9,13.25,41.25,52.53,41.25,52.53l8.2-6.56s-23.05-39.63-33.13-50c-4.11-23,1.06-57.48-8.49-70.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392 396.09 401.62 388.21 399.02 383.94 388.49 393.11 392 396.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.38,264.62l1.35,2.59c.1.2-.13.42-.47.42l-30.64.44c-.27,0-.48-.13-.51-.29l-.29-2.61c0-.18.21-.34.49-.34l29.58-.43A.58.58,0,0,1,358.38,264.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.41,268h.81c.15,0,.27-.09.26-.18l-.43-3.4c0-.1-.14-.17-.3-.17H354c-.16,0-.28.09-.26.18l.42,3.39C354.11,267.9,354.26,268,354.41,268Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.82,268.32h.8c.16,0,.27-.09.26-.19l-.41-3.39c0-.1-.16-.18-.32-.18h-.8c-.16,0-.28.09-.27.19l.42,3.39C330.52,268.24,330.66,268.32,330.82,268.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.62,268.13h.8c.16,0,.28-.09.27-.19l-.42-3.39c0-.11-.15-.19-.31-.18h-.8c-.16,0-.27.09-.27.19l.42,3.39C342.3,268.07,342.46,268.13,342.62,268.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.64 236.82 332.98 230.87 338.98 273.42 296.42 279.26 289.64 236.82",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.64 236.82 332.98 230.87 338.98 273.42 296.42 279.26 289.64 236.82",
    style: {
      fill: "#fff",
      opacity: 0.8,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.28,
    y: 230.89,
    width: 11.69,
    height: 44.34,
    transform: "matrix(0.99, -0.14, 0.14, 0.99, -31.36, 47.27)",
    style: {
      fill: "#407BFF",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.27,268.06l-6-2.35.59,7.5s4-.2,6.15-2.29Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.14,230.72c1.61,4.5,3,9,4.18,13.6.6,2.31,1.16,4.63,1.61,7,.22,1.2.41,2.42.55,3.69a25.66,25.66,0,0,1,.17,4,10.67,10.67,0,0,1-.4,2.57,7.42,7.42,0,0,1-1.61,2.77,12.77,12.77,0,0,1-3.75,2.77,33.27,33.27,0,0,1-7.24,2.53,76.06,76.06,0,0,1-14.25,1.91l-.47-3.77c2.19-.52,4.43-1.1,6.61-1.71s4.35-1.29,6.43-2.05a32.44,32.44,0,0,0,5.72-2.61,6.64,6.64,0,0,0,1.74-1.47c.13-.2.13-.25.11-.25a6.61,6.61,0,0,0,0-.89,21.46,21.46,0,0,0-.31-2.89c-.16-1-.38-2.12-.62-3.22-.5-2.14-1.06-4.33-1.69-6.52-1.25-4.34-2.66-8.75-4.07-13Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.74,269.41l.47,1.74a2.65,2.65,0,0,0,2.49,2l3.22.09-.59-7.49-3.28.37a2.66,2.66,0,0,0-2.38,2.92A2.7,2.7,0,0,0,333.74,269.41Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.73,222.34c3.36,1.37,6.11,12.41,6.11,12.41L357.56,242s-6.58-10.3-5.24-14.77C353.46,223.45,356.45,220.61,360.73,222.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.6,402.94h-.12a1,1,0,0,1-.81-.52.59.59,0,0,1-.05-.59c.41-.8,3-1.12,3.28-1.15a.16.16,0,0,1,.17.08.17.17,0,0,1,0,.19C398.53,401.68,397.48,402.88,396.6,402.94Zm1.95-1.87c-1,.15-2.41.48-2.61.92a.23.23,0,0,0,0,.25.62.62,0,0,0,.53.36c.5,0,1.3-.54,2.1-1.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.78,401c-.87,0-2.61-.31-3-1a.6.6,0,0,1,.14-.73.89.89,0,0,1,.7-.29c1.05,0,2.38,1.61,2.42,1.7a.15.15,0,0,1,0,.16.15.15,0,0,1-.13.11Zm-2.22-1.66a.59.59,0,0,0-.37.18c-.15.16-.12.26-.08.34.23.44,1.6.8,2.48.8a4,4,0,0,0-1.95-1.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.67,410.61a2.82,2.82,0,0,1-1.39-1,1.1,1.1,0,0,1-.08-.92.52.52,0,0,1,.38-.35c.92-.17,3.09,2.16,3.51,2.63a.18.18,0,0,1,0,.2.16.16,0,0,1-.18.08A11.51,11.51,0,0,1,300.67,410.61Zm-.69-1.88a.63.63,0,0,0-.33-.06s-.09,0-.13.12a.72.72,0,0,0,.06.64c.31.54,1.38,1.05,2.9,1.38A10.42,10.42,0,0,0,300,408.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.9,411.23l-.06,0c-.73-.73-1.92-2.92-1.51-3.62.09-.15.28-.31.71-.19,1.61.47,1.12,3.59,1.09,3.72a.13.13,0,0,1-.12.13A.11.11,0,0,1,302.9,411.23Zm-.8-3.49H302c-.16-.05-.28,0-.32,0-.24.41.53,2.06,1.23,2.94C302.9,409.91,303,408.14,302.1,407.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.08,191.23s-4,6.69-1,9.62,3.88-7.46,3.88-7.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.66,206.93s5-7.82,2.92-15.59-11.8-2.75-15.9-4.88a23.46,23.46,0,0,0-4.77-2.21,1.83,1.83,0,0,0-1.59.27c-1,.88.74,2.53,1.28,3.15a5.52,5.52,0,0,0-1.14-1c-.53-.35-1.24-.38-1,.51a4.4,4.4,0,0,0,2.08,2.2c-.39-.22-2.7-1.39-2.86-.66a.72.72,0,0,0,.13.5c1.5,2.8,4.52,6.32,8,6.39C343,195.67,347,207.46,351.66,206.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.43,207.28c-.26,2.64-4.18,2.67-4.18,2.67a8.48,8.48,0,0,1-3.07,3.72,22,22,0,0,0,.16,4.78c.66,2.49,1.5,3.35,2.55,3.91h0l-.84.83a11,11,0,0,1-5.28,1.47l-1.1-.64-1.44.23c-4-1.31-3-4-3-4a8.09,8.09,0,0,0,.11-5.71c-3.84-1.2-5.41-4.54-5.95-10.16s2.62-11,2.62-11c4.34,4.19,12.94,1.5,12.94,1.5-.37,7.88,3.31,10.79,3.31,10.79C351.47,204.59,353.68,204.65,353.43,207.28Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.47,208a4.42,4.42,0,0,0,2.51-1.84.33.33,0,0,0-.08-.45.32.32,0,0,0-.45.07,3.25,3.25,0,0,1-3.51,1.6.32.32,0,0,0-.4.21.33.33,0,0,0,.21.41A3.4,3.4,0,0,0,339.47,208Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.61,201.12c0,.51-.2.95-.54,1s-.65-.37-.69-.88.21-1,.55-1S340.57,200.6,340.61,201.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.49,200.86c0,.51-.2.95-.54,1s-.64-.37-.68-.88.2-.95.54-1S334.46,200.34,334.49,200.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.11,205.81l-.07-3.7-1.84,3.12A2.3,2.3,0,0,0,336.11,205.81Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.4,198a.34.34,0,0,0,.12-.06.42.42,0,0,0,.14-.59,3.47,3.47,0,0,0-3.27-1.68.42.42,0,0,0-.37.48.43.43,0,0,0,.48.37h0a2.64,2.64,0,0,1,2.43,1.28A.43.43,0,0,0,343.4,198Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.55,197.59a.45.45,0,0,0,.27-.2,1.68,1.68,0,0,1,1.68-.73.42.42,0,0,0,.5-.34.43.43,0,0,0-.34-.5,2.5,2.5,0,0,0-2.58,1.14.44.44,0,0,0,.15.59A.45.45,0,0,0,332.55,197.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.52 222.71 348.37 224.81 344.54 228.57 343.1 226.28 341.67 224.02 346.67 218.06 350.31 222.46 350.52 222.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.67 224.02 340.56 225.87 338.93 228.57 335.19 221.82 337.58 219.01 341.67 224.02",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogisticsRafiki);
export default __webpack_public_path__ + "static/media/Logistics-rafiki.789d35dc6aff10ca05c36a1f9f4b9265.svg";
export { ForwardRef as ReactComponent };